import TeamMember from '@/components/assemble/team/TeamMember'
import SvgLib from '@/components/SvgLib'
import { bus } from '@/consts.js'

export default {
  name: 'TeamBuilder',
  template: '#team-builder-template',
  components: { TeamMember, SvgLib },
  props: [
    'members',
    'romanTier',
    'rankOptions',
    'teammateCount',
    'exit',
    'title'
  ],
  data () {
    return {
      modalActive: false,
      modalShown: false
    }
  },
  computed: {
    finished () {
      return this.teammateCount >= 4
    },
    showTeamTier () {
      return this.teammateCount >= 1
    }
  },
  methods: {
    reset () {
      bus.$emit('resetData')
    },
    showModal () {
      this.modalActive = true
      this.modalShown = true
    }
  },
  mounted () {
    bus.$on('showInfo', () => {
      if (!this.modalShown) {
        this.showModal()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/team/TeamBuilder.js